import UltMeta, { Meta } from "./UltMeta/index";

class BusinessOpportunityType extends UltMeta {
    BUYING_INFORMATION = new Meta(1, "求购信息");

    FIND_MARKET = new Meta(2, "找销路");

    SEEK_COOPERATION = new Meta(3, "寻求合作");

    OTHER = new Meta(4, "其他信息");
}
export const BUSINESS_OPPORTUNITY_TYPE = new BusinessOpportunityType();

class BusinessOpportunityState extends UltMeta {
    TO_BE_REVIEWED = new Meta(1, "待审核");

    ON_SHELF = new Meta(2, "上架中");

    FAILED = new Meta(3, "未通过");

    OFF_SHELF = new Meta(4, "已下架");
}
export const BUSINESS_OPPORTUNITY_STATE = new BusinessOpportunityState();